import Web from "./Web";
function ContactUs() {
  return (
    <>
      <Web />
    </>
  );
}
export default ContactUs;
